<template>
    <div class="bulk_import_box">
        <el-dialog @close='closeDialog' title="批量导入题目" :visible.sync="dialogVisible">
            <div class="bulk_import_pop">
                <p class="step_text">第一步：</p>
                <div class="step_div">
                    <span>根据模板填写并上传文件</span>
                    <label @click="DownloadTemplate">下载模版</label>
                </div>
                <p class="step_text">第二步：</p>
                <div class="step_div step_div2">
                    <span>按照模版格式填写后上传Excel文件</span>
                    <el-upload class="upload-excel" :file-list="fileList" :on-exceed="handleExceed" :before-remove="beforeRemove" action="" :auto-upload="false" :on-change="handleImport" ref="upload">
                        <el-button plain>选择文件</el-button>
                    </el-upload>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureBtn()">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {importQuestionFile} from 'api/testPaperApi'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'excelImport',
        data() {
            return {
                dialogVisible: false,
                fileInfo: '',
                fileList: [],
                excelImportClassId: '',
                pageId:''
            }
        },
        mounted() {},
        methods: {
            // 打开弹窗
            openDialog(val) {
                this.dialogVisible = true;
                this.pageId=val;
            },
            // 关闭弹框
            closeDialog() {
                this.$nextTick(() => {
                    this.fileInfo = '';
                    this.$refs.upload.clearFiles();
                    this.dialogVisible = false
                })
            },
            // 下载模板
            DownloadTemplate() {
                window.open('http://img.capwhale.com/kmc/course/questionbank_template.xlsx')
            },
            // 确定按钮
            sureBtn() {
                if (this.fileInfo === '') {
                    this.$message.warning('请选择上传文件！')
                } else {
                    this.setLoading(true);
                    const fileInfo = this.fileInfo;
                    let formData = new FormData();
                    formData.append('innerid', this.pageId);
                    formData.append('filetype', 1);
                    formData.append('importfile', fileInfo);
                    console.log(formData)
                    importQuestionFile({
                        data: formData,
                        success: data => {
                            this.setLoading(false);
                            this.$message.success('导入成功');
                            this.closeDialog();
                            this.$emit('getQuesInfo')
                        },
                        error: data => {
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            // 文件上传限制提示
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
            },
            // 移除文件提示
            beforeRemove(file, fileList) {
                // return this.$confirm(`确定移除 ${ file.name }？`, '提示')
                return this.$confirm(`确定移除 ${file.name}？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 确定
                    this.fileInfo = ''
                })
            },
            // 导入弹窗导入EXCEL按钮
            handleImport(file, fileList) {
                this.fileInfo = file.raw;
                this.fileList = fileList.slice(-1)
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters([
                'user'
            ])
        },
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .bulk_import_box{
        .bulk_import_pop {
            padding: 14px;
            padding-bottom: 0;
            box-sizing: border-box;
            .step_text {
                line-height:20px;
                font-weight: bold;
                font-size: 14px;
                color:rgba(48,49,51,1);
            }
            .step_div {
                padding: 14px 0;
                .el-button {
                    margin-bottom: 0;
                }
                &>span {
                    margin-right: 20px;
                    line-height:20px;
                    font-size: 14px;
                    color:rgba(48,49,51,1);
                }
                &>label{
                    color: #409EFFFF;
                    cursor: pointer;
                }
                &>label:hover{
                    color: rgb(16, 129, 243);
                }
            }
            .step_div2 {
                display: flex;
                .upload-excel {
                    flex: 1;
                }
                .el-upload-list__item-name {
                    width: 270px;
                }
                &>span {
                    line-height:32px;
                }
            }
            .step_div3 {
                .el-button {
                    &>span{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
        .el-dialog__footer {
            padding: 0;
        }
    }
</style>
